export const comoDataTypes = {
  SET_COMO_DATA_FILTERS: 'SET_COMO_DATA_FILTERS',
  COMO_DATA_SELECTED: 'COMO_DATA_SELECTED',
  GET_COMO_DATA: 'GET_COMO_DATA',
  CREATE_COMO_DATA: 'CREATE_COMO_DATA',
  MOD_COMO_DATA: 'MOD_COMO_DATA',
  DELETE_COMO_DATA: 'DELETE_COMO_DATA',
  RESET_COMO_DATA_SELECTED: 'RESET_COMO_DATA_SELECTED',
  ADD_COMO_DATA_MODE: 'ADD_COMO_DATA_MODE',
  EDIT_COMO_DATA_MODE: 'EDIT_COMO_DATA_MODE',
  CHECK_ADD_COMO_DATA_MODE_PERMIT: 'CHECK_ADD_COMO_DATA_MODE_PERMIT',
  DELETE_COMO_DATA_MODE: 'DELETE_COMO_DATA_MODE',
  CLEAR_COMO_DATA: 'CLEAR_COMO_DATA',
  SET_CONFIG_FILTER_COMO_DATA: 'SET_CONFIG_FILTER_COMO_DATA',
  SET_CONFIG_PAGE_COMO_DATA: 'SET_CONFIG_PAGE_COMO_DATA',
  SET_CONFIG_PAGE_SIZE_COMO_DATA: 'SET_CONFIG_PAGE_SIZE_COMO_DATA',
  SET_CONFIG_SORTED_COMO_DATA: 'SET_CONFIG_SORTED_COMO_DATA',
  CLEAN_COMO_DATA: 'CLEAN_COMO_DATA',
}